import {useTranslation} from 'react-i18next'

export function FieldError({error, values}: {error?: string; values?: Record<string, string | number>}) {
  const {t} = useTranslation()
  if (!error) return null
  return <p className="text-xs text-destructive">{t(error, values)}</p>
}
